import React, { useEffect, useMemo, useState } from "react";
import "./EditAuditModal.css";
import EditIcon from "../../../../../common/assets/images/editaudit.png";
import DeleteIcon from "../../../../../common/assets/images/delete.png";
import AuditlistIcon from "../../../../../common/assets/images/checklist.png";
import CommentIcon from "../../../../../common/assets/images/message.png";
import auditbar from "../../../../../common/assets/images/auditbar.png";
import { useDispatch, useSelector } from "react-redux";
import UndoIcon from "@mui/icons-material/Undo";
import { updateAuditComment } from "../../EnhanceWorkflow/EnhanceWorkflowSlice";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
// import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {
  getAuditChangesTracking,
  saveAuditChangesTracking,
  REQUEST_STATUS,
  saveCodingChanges,
  getEnhanceWorkflowEpisodeDetails,
  getEnhancePlusFlags,
  getEnhanceAuditResults,
  startAuditSession,
  checkIfCodeExists,
} from "../../EnhanceWorkflow/EnhanceWorkflowSlice";
import { toast } from "react-toastify";
import { debounce } from "lodash";

export default function EditAuditModal({
  isOpen,
  data,
  onClose,
  onSave,
  splitCofAndCode,
  isEmptyCode,
}) {
  const dispatch = useDispatch();
  const {
    auditChangesTracking,
    saveAuditChanges,
    saveCodingChanges: saveCodingChangesState,
    updateAuditComment: updateAuditCommentState,
  } = useSelector((state) => state.codeEnhance);

  const [auditDrg, setAuditDrg] = useState(data?.currentDrg || "");
  const [auditNwau, setAuditNwau] = useState(data?.currentNwau || "");
  const [auditRevenue, setAuditRevenue] = useState(
    data?.currentDrgRevenue || "",
  );
  const auditChangesData = auditChangesTracking.data;
  const auditChangesStatus = auditChangesTracking.status;
  const codingSaveStatus = saveCodingChangesState.status;
  const commentSaveStatus = updateAuditCommentState.status;
  const saveStatus = saveAuditChanges.status;
  const [changes, setChanges] = useState({
    principalDiagnosis: false,
    additionalDiagnosis: false,
    procedureCodes: false,
    acs: false,
    acsOptionId: null,
    nationalCodingAdvice: false,
    stateCodingAdvice: false,
    enhanceAuditRule: false,
    enhanceAuditRuleText: "",
    other: false,
    otherText: "",
  });
  const [codeValidation, setCodeValidation] = useState({});
  const [coder, setCoder] = useState("");
  const [auditComments, setAuditComments] = useState("");
  const [codingRows, setCodingRows] = useState([]);
  const debouncedValidatorsRef = React.useRef({});
  const [editingCommentId, setEditingCommentId] = useState(null);
const [editedCommentText, setEditedCommentText] = useState("");
const [commentsOverride, setCommentsOverride] = useState({});
const [isDirty, setIsDirty] = useState(false);
const [isEditingCoder, setIsEditingCoder] = useState(false);
const [coderSaving, setCoderSaving] = useState(false);
  const mapSexToCode = (sex) => {
    if (!sex) return "";
    const s = sex.trim().toLowerCase();
    if (s === "male") return "M";
    if (s === "female") return "F";
    return sex.charAt(0).toUpperCase();
  };
  const patientDemographics = useMemo(
    () => ({
      u_agey: data?.hcp_line_detail?.c_agey ?? null,
      u_aged: data?.hcp_line_detail?.c_aged ?? null,
      sex: mapSexToCode(data?.hcp_line_detail?.sex),
    }),
    [data?.hcp_line_detail],
  );
  const getValidatorForRow = (rowId, checkFor) => {
    if (!debouncedValidatorsRef.current[rowId]) {
      debouncedValidatorsRef.current[rowId] = debounce(async (code) => {
        if (!code?.trim()) {
          setCodeValidation((prev) => ({
            ...prev,
            [rowId]: { status: "idle" },
          }));
          return;
        }

        setCodeValidation((prev) => ({
          ...prev,
          [rowId]: { status: "loading" },
        }));

        try {
          const payload = {
            u_agey: patientDemographics.u_agey,
            u_aged: patientDemographics.u_aged,
            sex: patientDemographics.sex,
            code: code.trim().toUpperCase(),
            check_for: checkFor, // "ICD" or "ACHI"
            check_type: "",
          };

          const res = await dispatch(checkIfCodeExists(payload)).unwrap();

          setCodeValidation((prev) => ({
            ...prev,
            [rowId]: {
              status: res.code_exists ? "valid" : "invalid",
              description: res.description || "",
              canonicalCode: res.canonical_code || "",
            },
          }));

          if (res.code_exists && res.canonical_code) {
            setCodingRows((rows) =>
              rows.map((r) =>
                r.id === rowId ? { ...r, auditCode: res.canonical_code } : r,
              ),
            );
          }
        } catch (err) {
          setCodeValidation((prev) => ({
            ...prev,
            [rowId]: {
              status: "invalid",
              description: "Unable to validate code",
            },
          }));
        }
      }, 500);
    }
    return debouncedValidatorsRef.current[rowId];
  };

  useEffect(() => {
    // cancel all pending debounced calls on unmount
    return () => {
      Object.values(debouncedValidatorsRef.current).forEach((fn) =>
        fn.cancel(),
      );
    };
  }, []);
  useEffect(() => {
    if (!isOpen) return;
    setCodingRows(buildCodingRowsFromDetail(data?.hcp_line_detail));
    setCodeValidation({});
      setCommentsOverride({}); 
  setEditingCommentId(null);
  setIsDirty(false);
    Object.values(debouncedValidatorsRef.current).forEach((fn) => fn.cancel());
    debouncedValidatorsRef.current = {};
  }, [isOpen, data?.hcp_line_detail]);
  // Compares just the code value (ignores COF) — same ICD/procedure code
  // shouldn't appear twice, regardless of onset flag.
const normalizeCodeForComparison = (code) =>
  code.replace(/[.\s]/g, "").toUpperCase();
  const isCodeInDeletedList = (rawCode, deletedList) => {
    if (!rawCode) return false;
    const normalized = normalizeCodeForComparison(rawCode);
    return (deletedList || []).some(
      (deletedCode) =>
        normalizeCodeForComparison(String(deletedCode || "")) === normalized,
    );
  };
const computeEffectiveCode = (row) => {
  const editedCode = row.auditCode?.trim();
  const baseCode = editedCode || row.currentCode?.trim() || "";
  return baseCode ? normalizeCodeForComparison(baseCode) : "";
};

  useEffect(() => {
    const activeRows = codingRows.filter((r) => !r.removed);
    const codeGroups = {};

    activeRows.forEach((row) => {
      const code = computeEffectiveCode(row);
      if (!code) return;

      const key = `${row.type}::${code}`;
      (codeGroups[key] = codeGroups[key] || []).push(row.id);
    });

    const duplicateIds = new Set();
    Object.values(codeGroups).forEach((ids) => {
      if (ids.length > 1) ids.forEach((id) => duplicateIds.add(id));
    });

    setCodeValidation((prev) => {
      let changed = false;
      const next = { ...prev };
      codingRows.forEach((row) => {
        const isDup = duplicateIds.has(row.id);
        const existing = next[row.id] || { status: "idle" };
        if (existing.isDuplicate !== isDup) {
          next[row.id] = { ...existing, isDuplicate: isDup };
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [codingRows]);
  const buildAuditSessionPayload = (hcpLineId, detail) => {
    const principal = detail?.principal_diagnosis;
    const principalCode = !isEmptyCode(principal?.code)
      ? principal.code.trim()
      : "";

    const additionalList = Array.isArray(detail?.additional_diagnosis)
      ? detail.additional_diagnosis
      : [];
    const additionalCodes = additionalList
      .filter((item) => !isEmptyCode(item?.code))
      .map((item) => item.code.trim());

    const procedureList = Array.isArray(detail?.procedure_codes)
      ? detail.procedure_codes
      : [];
    const procedureCodes = procedureList
      .filter((item) => !isEmptyCode(item?.code))
      .map((item) => String(item.code).trim());

    return {
      hcp_line_id: hcpLineId,
      principal_diagnosis_code: principalCode,
      additional_diagnosis_codes: additionalCodes,
      procedure_codes: procedureCodes,
    };
  };
  useEffect(() => {
    if (!isOpen || !data?.hcp_line_detail?.hcp_line_id) return;
    dispatch(getAuditChangesTracking(data.hcp_line_detail.hcp_line_id));
    dispatch(
      startAuditSession(
        buildAuditSessionPayload(
          data?.hcp_line_detail?.hcp_line_id,
          data.hcp_line_detail,
        ),
      ),
    );
  }, [isOpen, data?.hcp_line_detail?.hcp_line_id, dispatch]);

  useEffect(() => {
    if (auditChangesStatus !== REQUEST_STATUS.SUCCESS || !auditChangesData)
      return;

    const selectedAcsOption = auditChangesData.acs?.options?.find(
      (o) => o.is_clicked,
    );
    setChanges({
      principalDiagnosis: !!auditChangesData.principal_diagnoses?.is_clicked,
      additionalDiagnosis: !!auditChangesData.additional_diagnoses?.is_clicked,
      procedureCodes: !!auditChangesData.procedure_code?.is_clicked,
      acs: !!auditChangesData.acs?.is_clicked || !!selectedAcsOption,
      acsOptionId: selectedAcsOption?.id ?? null,
      nationalCodingAdvice:
        !!auditChangesData.national_coding_advice?.is_clicked,
      stateCodingAdvice: !!auditChangesData.state_coding_advice?.is_clicked,
      enhanceAuditRule: !!auditChangesData.enhance_audit_rule?.is_clicked,
      enhanceAuditRuleText: auditChangesData.enhance_audit_rule?.text || "",
      other: !!auditChangesData.others?.is_clicked,
      otherText: auditChangesData.others?.text || "",
    });
  }, [auditChangesStatus, auditChangesData]);
  const revenueDifference = useMemo(() => {
    const currentRevenue = parseCurrency(
      data?.hcp_line_detail?.current_drg_revenue,
    );
    const auditRevenueValue = parseCurrency(auditRevenue);

    if (currentRevenue == null || auditRevenueValue == null) {
      return "—";
    }

    const diff = auditRevenueValue - currentRevenue;
    const sign = diff > 0 ? "+" : diff < 0 ? "-" : "";

    return `${sign}$${Math.abs(diff).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }, [auditRevenue, data?.hcp_line_detail?.current_drg_revenue]);
const displayComments = useMemo(() => {
  const base = data?.hcp_line_detail?.comments || [];
  return base.map((c) =>
    commentsOverride[c.comment_id] !== undefined
      ? { ...c, comment: commentsOverride[c.comment_id] }
      : c,
  );
}, [data?.hcp_line_detail?.comments, commentsOverride]);
  if (!isOpen) return null;

 const toggleChange = (key) => {
  setChanges((c) => ({ ...c, [key]: !c[key] }));
  setIsDirty(true); 
};
  const joinCofAndCode = (cof, code) => `${cof || ""}${(code || "").trim()}`;
  const updateRow = (id, field, value) => {
    setCodingRows((rows) =>
      rows.map((r) => (r.id === id ? { ...r, [field]: value } : r)),
    );
    setIsDirty(true);
    if (field === "auditCode") {
      const row = codingRows.find((r) => r.id === id);
      const checkFor = row?.type === "procedure" ? "ACHI" : "ICD";
      getValidatorForRow(id, checkFor)(value);
    }
  };
  const removeRow = (id) => {
    setIsDirty(true);
    setCodingRows((rows) => {
      const row = rows.find((r) => r.id === id);
      if (!row) return rows;

      if (!row.isOriginal) {
        return rows.filter((r) => r.id !== id);
      }
      return rows.map((r) => (r.id === id ? { ...r, removed: true } : r));
    });

    // Drop any pending code-validation state for this row
    setCodeValidation((prev) => {
      const next = { ...prev };
      delete next[id];
      return next;
    });
  };

  const undoRemoveRow = (id) => {
     setIsDirty(true);
    setCodingRows((rows) =>
      rows.map((r) => (r.id === id ? { ...r, removed: false } : r)),
    );
  };

  const addDiagnosisRow = () => {
     setIsDirty(true);
    setCodingRows((rows) => [
      ...rows,
      {
        id: `diagnosis-${Date.now()}`,
        category: "Additional Diagnoses",
        cofCurrent: "",
        currentCode: "",
        cofAudit: "",
        auditCode: "",
        comment: "",
        removable: true,
        removed: false,
        isOriginal: false,
        type: "diagnosis",
      },
    ]);
  };

  const addProcedureRow = () => {
     setIsDirty(true);
    setCodingRows((rows) => [
      ...rows,
      {
        id: `procedure-${Date.now()}`,
        category: "Procedure Codes",
        cofCurrent: "",
        currentCode: "",
        cofAudit: "",
        auditCode: "",
        comment: "",
        removable: true,
        removed: false,
        isOriginal: false,
        type: "procedure",
      },
    ]);
  };

  const hasActivePrincipal = codingRows.some(
    (r) => r.category === "Principal Diagnosis" && !r.removed,
  );

  const addPrincipalDiagnosisRow = () => {
     setIsDirty(true);
    setCodingRows((rows) => [
      ...rows,
      {
        id: `principal-${Date.now()}`,
        category: "Principal Diagnosis",
        cofCurrent: "",
        currentCode: "",
        cofAudit: "",
        auditCode: "",
        comment: "",
        removable: true,
        removed: false,
        isOriginal: false,
        type: "diagnosis",
      },
    ]);
  };
  const buildAuditChangesIds = () => {
    if (!auditChangesData) return [];
    const ids = [];
    if (changes.principalDiagnosis)
      ids.push(auditChangesData.principal_diagnoses.id);
    if (changes.additionalDiagnosis)
      ids.push(auditChangesData.additional_diagnoses.id);
    if (changes.procedureCodes) ids.push(auditChangesData.procedure_code.id);
    if (changes.nationalCodingAdvice)
      ids.push(auditChangesData.national_coding_advice.id);
    if (changes.stateCodingAdvice)
      ids.push(auditChangesData.state_coding_advice.id);
    if (changes.enhanceAuditRule)
      ids.push(auditChangesData.enhance_audit_rule.id);
    if (changes.other) ids.push(auditChangesData.others.id);
    if (changes.acs) {
      ids.push(auditChangesData.acs.id);
      if (changes.acsOptionId) ids.push(changes.acsOptionId);
    }
    return ids;
  };
  const toCodeEntry = (row) => {
    const editedCode = row.auditCode?.trim();
    const cof = row.cofAudit || row.cofCurrent || "";

    const finalCode =
      row.type === "procedure"
        ? editedCode || row.currentCode?.trim() || ""
        : joinCofAndCode(cof, editedCode || row.currentCode);

    return {
      code: finalCode,
      code_comment: row.comment || "",
    };
  };

  const buildCodingChangesPayload = (hcpLineId) => {
    const principalRow = codingRows.find(
      (r) => r.category === "Principal Diagnosis" && !r.removed,
    );
    const additionalRows = codingRows.filter(
      (r) => r.category === "Additional Diagnoses" && !r.removed,
    );
    const procedureRows = codingRows.filter(
      (r) => r.category === "Procedure Codes" && !r.removed,
    );

    return {
      hcp_line_id: hcpLineId,
      audit_drg: auditDrg,
      audit_nwau: auditNwau === "" ? null : Number(auditNwau),
      audit_revenue: parseCurrency(auditRevenue),
      coder_name: coder,
      principal_diagnosis: principalRow ? toCodeEntry(principalRow) : null,
      additional_diagnosis: additionalRows.map(toCodeEntry),
      procedure_codes: procedureRows.map(toCodeEntry),
    };
  };
  const startsWithU = (code) => /^u/i.test((code || "").trim());

const sortRowsUCodesLast = (rows) => {

  return rows
    .map((row, idx) => ({ row, idx }))
    .sort((a, b) => {
      if (a.row.category !== b.row.category) return 0; // don't reorder across categories
      const aU = startsWithU(a.row.currentCode);
      const bU = startsWithU(b.row.currentCode);
      if (aU === bU) return a.idx - b.idx; // stable within same bucket
      return aU ? 1 : -1; // U-codes sink to the bottom
    })
    .map(({ row }) => row);
};
const buildCodingRowsFromDetail = (detail) => {
    if (!detail) return [];
    const rows = [];

    const deletedCodes = detail.deleted_codes || {};
    const deletedPrincipal = deletedCodes.principal_diagnosis_code || "";
    const deletedAdditional = deletedCodes.additional_diagnosis_codes || [];
    const deletedProcedures = deletedCodes.procedure_codes || [];

    // Principal Diagnosis
    const principal = detail.principal_diagnosis;
    const principalHasCode = !isEmptyCode(principal?.code);
    const { cof: principalCof, code: principalCode } = principalHasCode
      ? splitCofAndCode(principal.code)
      : { cof: "", code: "" };

    const principalIsDeleted =
      principalHasCode &&
      (isCodeInDeletedList(principal.code, [deletedPrincipal]) ||
        isCodeInDeletedList(principalCode, [deletedPrincipal]));

    rows.push({
      id: "principal",
      category: "Principal Diagnosis",
      cofCurrent: principalCof,
      currentCode: principalCode,
      cofAudit: "",
      auditCode: "",
      comment: principal?.code_comment || "",
      removable: false,
      removed: principalIsDeleted,
      isOriginal: true,
      type: "diagnosis",
    });

    if (
      !principalHasCode &&
      deletedPrincipal &&
      !isEmptyCode(deletedPrincipal)
    ) {
      const { cof: delCof, code: delCode } = splitCofAndCode(deletedPrincipal);
      rows.push({
        id: "principal-deleted",
        category: "Principal Diagnosis",
        cofCurrent: delCof,
        currentCode: delCode,
        cofAudit: "",
        auditCode: "",
        comment: "",
        removable: false,
        removed: true,
        isOriginal: true,
        type: "diagnosis",
      });
    }

    const additionalList = Array.isArray(detail.additional_diagnosis)
      ? detail.additional_diagnosis
      : [];
    additionalList.forEach((item, idx) => {
      if (!isEmptyCode(item?.code)) {
        const { cof, code } = splitCofAndCode(item.code);
        rows.push({
          id: `additional-${idx + 1}`,
          category: "Additional Diagnoses",
          cofCurrent: cof,
          currentCode: code,
          cofAudit: "",
          auditCode: "",
          comment: item.code_comment || "",
          removable: true,
          removed:
            isCodeInDeletedList(item.code, deletedAdditional) ||
            isCodeInDeletedList(code, deletedAdditional),
          isOriginal: true,
          type: "diagnosis",
        });
      }
    });

    deletedAdditional.forEach((delCode, idx) => {
      if (!delCode || isEmptyCode(delCode)) return;
      const alreadyPresent = additionalList.some(
        (item) => !isEmptyCode(item?.code) && isCodeInDeletedList(item.code, [delCode]),
      );
      if (alreadyPresent) return; // already rendered + marked removed above

      const { cof, code } = splitCofAndCode(delCode);
      rows.push({
        id: `additional-deleted-${idx}`,
        category: "Additional Diagnoses",
        cofCurrent: cof,
        currentCode: code,
        cofAudit: "",
        auditCode: "",
        comment: "",
        removable: true,
        removed: true,
        isOriginal: true,
        type: "diagnosis",
      });
    });

    const procedureList = Array.isArray(detail.procedure_codes)
      ? detail.procedure_codes
      : [];
    procedureList.forEach((item, idx) => {
      if (!isEmptyCode(item?.code)) {
        rows.push({
          id: `procedure-${idx + 1}`,
          category: "Procedure Codes",
          cofCurrent: "",
          currentCode: String(item.code).trim(),
          cofAudit: "",
          auditCode: "",
          comment: item.code_comment || "",
          removable: true,
          removed: isCodeInDeletedList(item.code, deletedProcedures),
          isOriginal: true,
          type: "procedure",
        });
      }
    });
    deletedProcedures.forEach((delCode, idx) => {
      if (!delCode || isEmptyCode(delCode)) return;
      const alreadyPresent = procedureList.some(
        (item) => !isEmptyCode(item?.code) && isCodeInDeletedList(String(item.code), [delCode]),
      );
      if (alreadyPresent) return;

      rows.push({
        id: `procedure-deleted-${idx}`,
        category: "Procedure Codes",
        cofCurrent: "",
        currentCode: String(delCode).trim(),
        cofAudit: "",
        auditCode: "",
        comment: "",
        removable: true,
        removed: true,
        isOriginal: true,
        type: "procedure",
      });
    });

    return sortRowsUCodesLast(rows);
};

  const handleCancel = () => {
    resetFields();
    onClose?.();
  };
  const resetFields = () => {
    setAuditDrg(data?.currentDrg || "");
    setAuditNwau(data?.currentNwau || "");
    setAuditRevenue(data?.currentDrgRevenue || "");

    setChanges({
      principalDiagnosis: false,
      additionalDiagnosis: false,
      procedureCodes: false,
      acs: false,
      acsOptionId: null,
      nationalCodingAdvice: false,
      stateCodingAdvice: false,
      enhanceAuditRule: false,
      other: false,
      otherText: "",
    });

    // Rebuild coding rows fresh from source data (clears any typed auditCode/cofAudit edits)
    setCodingRows(buildCodingRowsFromDetail(data?.hcp_line_detail));

    setCoder("");
    setAuditComments("");
  };
  const clearAuditInputs = () => {
    setCodingRows((rows) =>
      rows.map((row) => ({
        ...row,
        auditCode: "",
        cofAudit: "", // clear back to blank, not cofCurrent
        comment: "", // optional — remove if you want comments to persist
      })),
    );
  };
  const handleSaveCoder = async () => {
  const hcpLineId = data?.hcp_line_detail?.hcp_line_id;
  const updatedCoder = coder.trim();

  if (!hcpLineId) {
    toast.error("Missing episode reference (hcp_line_id)");
    return;
  }

  if (!updatedCoder) {
    toast.error("Coder name cannot be empty");
    return;
  }

  setCoderSaving(true);

  try {
    const payload = {
      hcp_line_id: hcpLineId,
      audit_drg: auditDrg,
      audit_nwau: auditNwau === "" ? null : Number(auditNwau),
      audit_revenue: parseCurrency(auditRevenue),
      coder_name: updatedCoder,
      principal_diagnosis: null,
      additional_diagnosis: [],
      procedure_codes: [],
    };

    console.log("Updating coder payload:", payload);

    const response = await dispatch(
      saveCodingChanges(payload)
    ).unwrap();

    toast.success(
      response?.message || "Coder updated successfully"
    );

    // Update local state
    setCoder(updatedCoder);
    setIsEditingCoder(false);
    setIsDirty(false);

    // Refresh episode details
    dispatch(getEnhanceWorkflowEpisodeDetails(hcpLineId));
    dispatch(getEnhancePlusFlags(hcpLineId));
    dispatch(getEnhanceAuditResults(hcpLineId));

    // Notify parent
    onSave?.({
      episodeId: data?.episodeId,
      coder: updatedCoder,
    });
  } catch (err) {
    console.error("Failed to update coder:", err);

    toast.error(
      err?.message || err || "Failed to update coder"
    );
  } finally {
    setCoderSaving(false);
  }
};

  const handleSave = async () => {
    const hcpLineId = data?.hcp_line_detail?.hcp_line_id;
    const duplicateRow = codingRows.find(
      (row) => !row.removed && codeValidation[row.id]?.isDuplicate,
    );
    if (duplicateRow) {
      toast.error(
        `Duplicate code detected in ${duplicateRow.category}. Please remove or correct the duplicate before saving.`,
      );
      return;
    }
    if (!hcpLineId) {
      toast.error("Missing episode reference (hcp_line_id)");
      return;
    }
    const stillValidating = codingRows.some(
      (row) => codeValidation[row.id]?.status === "loading",
    );
    if (stillValidating) {
      toast.error("Please wait, validating audit codes...");
      return;
    }
    const invalidRow = codingRows.find(
      (row) => codeValidation[row.id]?.status === "invalid",
    );
    if (invalidRow) {
      toast.error(
        `Invalid audit code entered for ${invalidRow.category}. Please correct it before saving.`,
      );
      return;
    }

    // COF check
    const missingCofRow = codingRows.find(
      (row) =>
        row.type === "diagnosis" &&
        row.auditCode?.trim() &&
        !row.cofAudit?.trim(),
    );

    if (missingCofRow) {
      toast.error(
        `COF is not entered for ${missingCofRow.category}. Please enter COF before saving.`,
      );
      return;
    }

    const trackingPayload = {
      hcp_line_id: hcpLineId,
      audit_changes: buildAuditChangesIds(),
      other_comment: changes.other ? changes.otherText : "",
      audit_comment: auditComments,
      enhance_rule_comment: changes.enhanceAuditRuleText,
    };

    const codingPayload = buildCodingChangesPayload(hcpLineId);

    try {
      const [trackingRes, codingRes] = await Promise.all([
        dispatch(saveAuditChangesTracking(trackingPayload)).unwrap(),
        dispatch(saveCodingChanges(codingPayload)).unwrap(),
      ]);

      toast.success(
        codingRes?.message ||
          trackingRes?.message ||
          "Audit changes saved successfully",
      );
      dispatch(getEnhanceWorkflowEpisodeDetails(hcpLineId));
      dispatch(getEnhancePlusFlags(hcpLineId));
      dispatch(getEnhanceAuditResults(hcpLineId));
      setIsDirty(false);
      onSave?.({
        episodeId: data?.episodeId,
        auditDrg,
        auditNwau,
        auditRevenue,
        revenueDifference,
        changes,
        codingRows,
        coder,
        auditComments,
        savedPayload: { trackingPayload, codingPayload },
      });
      clearAuditInputs();
      // onClose?.();
    } catch (err) {
      toast.error(err || "Failed to save audit changes");
    }
  };
  const acsOptions = auditChangesData?.acs?.options || [];
  function getInitials(name) {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/);
    const initials =
      parts.length === 1
        ? parts[0].slice(0, 2)
        : parts[0][0] + parts[parts.length - 1][0];
    return initials.toUpperCase();
  }
  const NWAU_RATE = 7258;

  const handleAuditNwauChange = (value) => {
    setAuditNwau(value);
    setIsDirty(true);
    const numericNwau = parseFloat(value);
    if (value === "" || Number.isNaN(numericNwau)) {
      setAuditRevenue("");
      return;
    }

    const computedRevenue = numericNwau * NWAU_RATE;
    setAuditRevenue(computedRevenue.toFixed(2));
  };

  const handleAuditRevenueChange = (value) => {
    setAuditRevenue(value);
     setIsDirty(true);
    const numericRevenue = parseCurrency(value);
    if (value === "" || numericRevenue == null) {
      setAuditNwau("");
      return;
    }

    const computedNwau = numericRevenue / NWAU_RATE;
    setAuditNwau(computedNwau.toFixed(4));
  };
  const startEditComment = (c) => {
  setEditingCommentId(c.comment_id);
  setEditedCommentText(c.comment);
};

const cancelEditComment = () => {
  setEditingCommentId(null);
  setEditedCommentText("");
};

const saveEditComment = async (commentId) => {
  const trimmed = editedCommentText.trim();
  if (!trimmed) {
    toast.error("Comment cannot be empty");
    return;
  }
  try {
    await dispatch(
      updateAuditComment({ comment_id: commentId, updated_comment: trimmed }),
    ).unwrap();

    setCommentsOverride((prev) => ({ ...prev, [commentId]: trimmed }));
    setEditingCommentId(null);
    setEditedCommentText("");
    toast.success("Comment updated successfully");

    // NEW — refetch episode details so comments list reflects the server's latest state
    const hcpLineId = data?.hcp_line_detail?.hcp_line_id;
    if (hcpLineId) {
      dispatch(getEnhanceWorkflowEpisodeDetails(hcpLineId));
    }
  } catch (err) {
    toast.error(err || "Failed to update comment");
  }
};
  function formatCommentDate(dateStr) {
    if (!dateStr) return "";
    return dateStr; // already formatted as "13-07-2026" from API — adjust if you want to reformat
  }

function AuditCommentHistory({ comments }) {
  const validComments = (comments || []).filter((c) => c.comment?.trim());

  if (validComments.length === 0) {
    return <div className="eam-comment-empty">No previous comments</div>;
  }

  return (
    <div className="eam-comment-list">
      {validComments.map((c) => {
        const isEditing = editingCommentId === c.comment_id;
        const isSaving =
          isEditing && commentSaveStatus === REQUEST_STATUS.LOADING;

        return (
          <div key={c.comment_id} className="eam-comment-item">
            <span className="eam-comment-avatar">
              {(c.username || "?").charAt(0).toUpperCase()}
            </span>
            <div className="eam-comment-content">
              <div className="eam-comment-meta">
                <span className="eam-comment-author">
                  {c.username || "Unknown"}
                </span>
                <span className="eam-comment-date">
                  {formatCommentDate(c.date)}
                </span>
              </div>

            {isEditing ? (
  <div className="eam-comment-edit-row">
    <input
      className="eam-cell-input eam-comment-edit-input"
      value={editedCommentText}
      autoFocus
      disabled={isSaving}
      onChange={(e) => setEditedCommentText(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") saveEditComment(c.comment_id);
        if (e.key === "Escape") cancelEditComment();
      }}
    />
    <button
      type="button"
      className="eam-comment-icon-btn eam-comment-save-btn"
      aria-label="Save comment"
      disabled={isSaving}
      onClick={() => saveEditComment(c.comment_id)}
    >
      <CheckIcon fontSize="small" />
    </button>
    <button
      type="button"
      className="eam-comment-icon-btn eam-comment-cancel-btn"
      aria-label="Cancel edit"
      disabled={isSaving}
      onClick={cancelEditComment}
    >
      <CloseIcon fontSize="small" />
    </button>
  </div>
) : (
  <div className="eam-comment-text-row">
    <div className="eam-comment-text">{c.comment}</div>
    <button
      type="button"
      className="eam-comment-icon-btn eam-comment-edit-btn"
      aria-label="Edit comment"
      onClick={() => startEditComment(c)}
    >
      <EditOutlinedIcon fontSize="small" />
    </button>
  </div>
)}
            </div>
          </div>
        );
      })}
    </div>
  );
}
const handleAuditDrgChange = (value) => { // NEW
  setAuditDrg(value);
  setIsDirty(true);
};
  return (
    <div
      className="eam-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="eam-title"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) handleCancel();
      }}
    >
      <div className="eam-modal">
        <div className="eam-header">
          <span className="eam-header-icon" aria-hidden>
            <img src={EditIcon} alt="Edit" />
          </span>
          <h2 id="eam-title" className="eam-title">
            Edit Audit
          </h2>
          <button
            className="eam-close"
            aria-label="Close"
            onClick={handleCancel}
          >
            ×
          </button>
        </div>

        <div className="eam-body">
          {/* Audit Results */}
          <section className="eam-panel">
            <div className="eam-panel-header">
              <span className="eam-panel-icon" aria-hidden>
                <img src={auditbar} alt="Edit" />
              </span>
              Audit Results
            </div>
            <div className="eam-grid-4">
              <ReadonlyField
                label="Current DRG"
                value={data?.hcp_line_detail?.drg_code}
              />
              <ReadonlyField
                label="Current NWAU"
                value={data?.hcp_line_detail?.current_NWAU}
              />
              <ReadonlyField
                label="Current Revenue"
                value={data?.hcp_line_detail?.current_drg_revenue}
              />
              <ReadonlyField
                label="DRG Version"
                value={data?.hcp_line_detail?.ar_drg_version}
              />

              <EditableField
                label="Audit DRG"
                value={auditDrg}
                onChange={handleAuditDrgChange}
              />
              <EditableField
                label="Audit NWAU"
                value={auditNwau}
                onChange={handleAuditNwauChange}
              />
              <EditableField
                label="Audit Revenue"
                value={auditRevenue}
                onChange={handleAuditRevenueChange}
              />
              <div className="eam-field">
                <label className="eam-label">Revenue Difference</label>
                <div
                  className={`eam-revenue-diff ${revenueDifference.startsWith("-") ? "eam-diff-neg" : "eam-diff-pos"}`}
                >
                  {revenueDifference}
                </div>
              </div>
            </div>
          </section>

          {/* Audit Changes */}
          <section className="eam-panel">
            <div className="eam-panel-header">
              <span className="eam-panel-icon" aria-hidden>
                <img src={AuditlistIcon} alt="Edit" />
              </span>
              Audit Changes
              {auditChangesStatus === REQUEST_STATUS.LOADING && (
                <span style={{ marginLeft: 8, fontSize: 12, opacity: 0.6 }}>
                  Loading…
                </span>
              )}
            </div>
            <div className="eam-changes-grid">
              <CheckboxItem
                label="Principal Diagnosis"
                checked={changes.principalDiagnosis}
                onChange={() => toggleChange("principalDiagnosis")}
              />
              <CheckboxItem
                label="Additional Diagnosis"
                checked={changes.additionalDiagnosis}
                onChange={() => toggleChange("additionalDiagnosis")}
              />
              <CheckboxItem
                label="Procedure Code/s"
                checked={changes.procedureCodes}
                onChange={() => toggleChange("procedureCodes")}
              />
              <div className="eam-checkbox-row">
                <CheckboxItem
                  label="ACS"
                  checked={changes.acs}
                  onChange={() => toggleChange("acs")}
                  bare
                />
                <select
                  className="eam-inline-select"
                  value={changes.acsOptionId ?? ""}
                  disabled={!changes.acs}
                  onChange={(e) =>{
                    setChanges((c) => ({
                      ...c,
                      acsOptionId: e.target.value
                        ? Number(e.target.value)
                        : null,
                    }))
                    setIsDirty(true);}
                  }

                >
                  <option value="">Select</option>
                  {acsOptions.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                      {opt.code}
                    </option>
                  ))}
                </select>
              </div>

              <CheckboxItem
                label="National Coding Advice"
                checked={changes.nationalCodingAdvice}
                onChange={() => toggleChange("nationalCodingAdvice")}
              />
              <CheckboxItem
                label="State Coding Advice"
                checked={changes.stateCodingAdvice}
                onChange={() => toggleChange("stateCodingAdvice")}
              />
              <div className="eam-checkbox-row">
                <CheckboxItem
                  label=""
                  checked={changes.enhanceAuditRule}
                  onChange={() => toggleChange("enhanceAuditRule")}
                />
                <input
                  type="text"
                  className="eam-inline-text"
                  placeholder="Enhance Audit rule"
                  disabled={!changes.enhanceAuditRule}
                  value={changes.enhanceAuditRuleText}
                  onChange={(e) =>{
                    setChanges((c) => ({
                      ...c,
                      enhanceAuditRuleText: e.target.value,
                    }))
                    setIsDirty(true);}
                  }
                />
              </div>
              <div className="eam-checkbox-row">
                <CheckboxItem
                  label="Other"
                  checked={changes.other}
                  onChange={() => toggleChange("other")}
                  bare
                />
                <input
                  type="text"
                  className="eam-inline-text"
                  placeholder="Add Text"
                  disabled={!changes.other}
                  value={changes.otherText}
                  onChange={(e) =>{
                    setChanges((c) => ({ ...c, otherText: e.target.value }))
                    setIsDirty(true);
                  }
                  }
                />
              </div>
            </div>
          </section>

          {/* Coding Changes */}
          <div className="eam-section-title">Coding Changes</div>
          <div className="eam-table-wrap">
            <table className="eam-table">
              <thead>
                <tr>
                  <th>Category</th>
                  <th className="eam-col-narrow">COF</th>
                  <th>Current Coding</th>
                  <th className="eam-col-narrow">COF</th>
                  <th>Audit Coding</th>
                  <th>Comments</th>
                </tr>
              </thead>
              <tbody>
                {codingRows.map((row) => (
                  <tr
                    key={row.id}
                    className={row.removed ? "eam-row-removed" : ""}
                  >
                    <td className="eam-strong">{row.category}</td>

                    <td>
                      {row.type === "diagnosis" ? (
                        <span className="eam-cof-static">
                          {row.cofCurrent || "—"}
                        </span>
                      ) : (
                        <span></span>
                      )}
                    </td>

                    <td>
                      <div className="eam-code-pill">
                        <span
                          className={`eam-code-pill-text ${row.removed ? "eam-code-strikethrough" : ""}`}
                        >
                          {row.currentCode || "—"}
                        </span>

                        {row.removed && (
                          <span className="eam-removed-badge">REMOVED</span>
                        )}

                        {row.removable &&
                          (row.removed ? (
                            <button
                              type="button"
                              className="eam-undo-btn"
                              aria-label={`Undo remove ${row.category}`}
                              onClick={() => undoRemoveRow(row.id)}
                            >
                              <UndoIcon fontSize="small" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="eam-delete-btn"
                              aria-label={`Remove ${row.category}`}
                              onClick={() => removeRow(row.id)}
                            >
                              <img src={DeleteIcon} alt="Delete" />
                            </button>
                          ))}
                      </div>
                    </td>

                    <td>
                      {row.type === "diagnosis" && !row.removed ? (
                        <div className="eam-cof-input-wrap">
                          <input
                            className="eam-cell-input eam-cell-narrow"
                            value={row.cofAudit}
                            onChange={(e) =>
                              updateRow(row.id, "cofAudit", e.target.value)
                            }
                          />
                          {row.auditCode?.trim() && !row.cofAudit?.trim() && (
                            <span
                              className="eam-mandatory-mark"
                              title="COF is required"
                            >
                              *
                            </span>
                          )}
                        </div>
                      ) : (
                        <span></span>
                      )}
                    </td>

                    <td>
                      {row.removed ? (
                        <span className="eam-removed-placeholder">---</span>
                      ) : (
                        <>
                          <input
                            className={`eam-cell-input ${
                              codeValidation[row.id]?.isDuplicate ||
                              codeValidation[row.id]?.status === "invalid"
                                ? "eam-input-invalid"
                                : ""
                            }`}
                            placeholder="Enter audit code"
                            value={row.auditCode}
                            onChange={(e) =>
                              updateRow(row.id, "auditCode", e.target.value)
                            }
                          />
                          {codeValidation[row.id]?.isDuplicate ? (
                            <div className="eam-code-hint eam-code-invalid">
                              ✕ Duplicate code — already used in another row
                            </div>
                          ) : (
                            <>
                              {codeValidation[row.id]?.status === "loading" && (
                                <div className="eam-code-hint eam-code-loading">
                                  Checking code…
                                </div>
                              )}
                              {codeValidation[row.id]?.status === "valid" && (
                                <div className="eam-code-hint eam-code-valid">
                                  ✓ {codeValidation[row.id].description}
                                </div>
                              )}
                              {codeValidation[row.id]?.status === "invalid" && (
                                <div className="eam-code-hint eam-code-invalid">
                                  ✕ Invalid code — code not found
                                </div>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </td>

                    <td>
                      <input
                        className="eam-cell-input eam-cell-comment"
                        placeholder="Add comment..."
                        value={row.comment}
                        disabled={row.removed}
                        onChange={(e) =>
                          updateRow(row.id, "comment", e.target.value)
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="eam-add-row-actions">
            {!hasActivePrincipal && (
              <button
                type="button"
                className="eam-link-btn"
                onClick={addPrincipalDiagnosisRow}
              >
                <span aria-hidden>+</span> Add Principal Diagnosis
              </button>
            )}
            <button
              type="button"
              className="eam-link-btn"
              onClick={addDiagnosisRow}
            >
              <span aria-hidden>+</span> Add Diagnosis
            </button>
            <button
              type="button"
              className="eam-link-btn"
              onClick={addProcedureRow}
            >
              <span aria-hidden>+</span> Add Procedure Code
            </button>
          </div>

         
       
            
        {/* Coder */}
<div className="eam-field eam-field-block">
  <label className="eam-label eam-label-bold">Coder</label>

  {!isEditingCoder ? (
    <div className="eam-coder-chip">
      <span className="eam-coder-avatar">
        {getInitials(data?.hcp_line_detail?.coder_name)}
      </span>

      <span className="eam-coder-name">
        {data?.hcp_line_detail?.coder_name ||
          "No information available"}
      </span>

      {/* Same pencil design as Audit Comments */}
      <button
        type="button"
        className="eam-comment-icon-btn eam-comment-edit-btn"
        aria-label="Edit coder"
        onClick={() => {
          setCoder(data?.hcp_line_detail?.coder_name || "");
          setIsEditingCoder(true);
          setIsDirty(true);
        }}
      >
        <EditOutlinedIcon fontSize="small" />
      </button>
    </div>
  ) : (
    <div className="eam-coder-edit-row">
      <input
        type="text"
        className="eam-text-input eam-input-editable"
        value={coder}
        autoFocus
        placeholder="Enter coder name"
        onChange={(e) => {
          setCoder(e.target.value);
          setIsDirty(true);
        }}
      />

      {/* Save */}
      <button
        type="button"
        className="eam-comment-icon-btn eam-comment-save-btn"
        aria-label="Save coder"
        disabled={coderSaving}
        onClick={handleSaveCoder}
        // onClick={() => {
        //   setIsEditingCoder(false);
        //   setIsDirty(true);
        // }}
      >
        <CheckIcon fontSize="small" />
      </button>

      {/* Cancel */}
      <button
        type="button"
        className="eam-comment-icon-btn eam-comment-cancel-btn"
        aria-label="Cancel coder edit"
        onClick={() => {
          setCoder(data?.hcp_line_detail?.coder_name || "");
          setIsEditingCoder(false);
        }}
      >
        <CloseIcon fontSize="small" />
      </button>
    </div>
  )}
</div>

          {/* Audit Comments */}
          <div className="eam-field eam-field-block">
            <label className="eam-label eam-label-bold eam-with-icon">
              <span aria-hidden>
                <img src={CommentIcon} alt="Edit" />
              </span>{" "}
              Audit Comments
            </label>
            <AuditCommentHistory comments={data?.hcp_line_detail?.comments} />
            <textarea
              className="eam-textarea"
              placeholder="Add detailed audit justifications or notes here..."
              value={auditComments}
              onChange={(e) => {setAuditComments(e.target.value)
                 setIsDirty(true);}
              }
              rows={4}
            />
          </div>
        </div>

        <div className="eam-footer">
          <button
            type="button"
            className="eam-btn eam-btn-cancel"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="eam-btn eam-btn-primary"
            onClick={handleSave}
            disabled={
               !isDirty||
              saveStatus === REQUEST_STATUS.LOADING ||
              codingSaveStatus === REQUEST_STATUS.LOADING 
            }
          >
            {saveStatus === REQUEST_STATUS.LOADING ||
            codingSaveStatus === REQUEST_STATUS.LOADING
              ? "Saving..."
              : "Save Audit Changes"}
          </button>
        </div>
      </div>
    </div>
  );
}

function ReadonlyField({ label, value }) {
  const displayValue =
    value == null || value === "NaN" || value.trim?.().toLowerCase() === "nan"
      ? "-"
      : value;

  return (
    <div className="eam-field">
      <label className="eam-label">{label}</label>
      <input
        className="eam-text-input eam-input-readonly"
        value={displayValue}
        readOnly
        disabled
      />
    </div>
  );
}

function EditableField({ label, value, onChange }) {
  return (
    <div className="eam-field">
      <label className="eam-label">{label}</label>
      <input
        className="eam-text-input eam-input-editable"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

function CheckboxItem({
  label,
  checked,
  onChange,
  disabled = false,
  bare = false,
}) {
  return (
    <label className={bare ? "eam-checkbox eam-checkbox-bare" : "eam-checkbox"}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span
        className={
          disabled
            ? "eam-checkbox-label eam-checkbox-label-disabled"
            : "eam-checkbox-label"
        }
      >
        {label}
      </span>
    </label>
  );
}

function parseCurrency(value) {
  if (value == null) return null;
  const cleaned = String(value).replace(/[^0-9.-]/g, "");
  if (cleaned === "" || cleaned === "-") return null;
  const n = Number(cleaned);
  return Number.isNaN(n) ? null : n;
}